export default "__VITE_ASSET__D$WXztFP__"